import {Column, TID} from "./Table";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";

export function SimpleRenderTable<T extends TID>(props: {
    data: T[];
    columns: (Column<T>|false|null)[];
    getRowStyle?: (input: T) => any;
}) {

    const {data, columns} = props;

    return (
        <div style={{
            backgroundColor: grey["100"],
            width: "100%",
        }}>
            <table className={tableCss} style={{
                width: data.length === 0 ? columns.reduce((a, c) => a + (c ? c.width || 0 : 0), 0) : undefined,
            }}>
                {data.length > 0 && <thead>
                    <tr>
                        {columns.map((c, i) => c ? <th key={c.name} style={{
                            width: c.width,
                        }}>{
                            c.renderName ? c.renderName() : c.name
                        }</th> : null)}
                    </tr>
                </thead>}
                <tbody>
                    {data.map((row, i) => (
                        <tr key={row.id.toString()} style={props.getRowStyle?.(row)}>
                            {columns.map((c, j) => c ?
                                <td key={c.name} style={{
                                    textAlign: c.alignRight ? "right": undefined,
                                }}>{c.render(row, c)}</td> : null)}
                        </tr>
                    ))}
                    {data.length === 0 && <tr key="blank">
                        <td colSpan={columns.length} style={{textAlign: "center", fontSize: "0.75rem"}}>No items</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    )
}

const tableCss = css({
    borderCollapse: "collapse",
    borderLeft: "1px solid " + grey["200"],
    borderRight: "1px solid " + grey["200"],

    "& > thead th": {
        borderBottom: "1px solid " + grey["300"],
        fontSize: "0.8rem",
        textAlign: "left",
        paddingLeft: 4,
        paddingRight: 4,
        fontWeight: "normal",
    },

    "& td": {
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: "0.8rem",
        position: "relative",
    },

    "& > tbody > tr:nth-child(odd) > td": {
        backgroundColor: "rgba(0,0,0,.05)",
    }
})